<template>
  <div>
    <van-sticky>
      <van-nav-bar
        title="运动会序号管理"
        left-text="返回"
        right-text="预览"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onPreview"
      >
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item @change="dropdownItemChange" v-model="gender" :options="genders"/>
        <van-dropdown-item @change="dropdownItemChange" v-model="sgroup" :options="sgroups"/>
        <van-dropdown-item @change="dropdownItemChange" v-model="category" :options="categorys"/>
        <van-dropdown-item @change="dropdownItemChange" v-model="progress" :options="progresses"/>
      </van-dropdown-menu>

    </van-sticky>

    <van-cell-group>
      <van-cell v-for="(item, index) in sportsMeetTitleList" :key="item.key" :title="item.key"
                :label="item.value!=0?('序号:'+item.value):'未编排'">
        <template #right-icon>
          <van-button type="primary" size="mini" @click="dialogShow(item.key)">修改编号</van-button>
        </template>
      </van-cell>
    </van-cell-group>
    <van-dialog v-model="show" title="序号修改" @confirm="changeSerial" show-cancel-button>
      <van-cell-group>
        <van-field v-model="serial" label="编号" type="number" placeholder="请输入编号"/>
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="previewShow" title="已编排序号列表">
      <div style="overflow: scroll;height: 500px">
        <van-cell-group style="margin: 10px;">
          <van-cell v-for="item in previewList" :key="item.serial" :title="`第${item.serial}组   ${item.category}`"/>
        </van-cell-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Popup,
  Sticky,
  Cascader,
  Field,
  Icon,
  Popover,
  Dialog,
  Toast,
  ActionSheet,
  Button,
  Uploader,
  Cell,
  CellGroup,
  Divider,
  Tab, Tabs,
  DropdownMenu,
  DropdownItem, Checkbox, CheckboxGroup
} from 'vant';
import {GetSportsMeetTitleList, ChangeSportsMeetSerial, GetSerial,GetSportsMeetMultiTypes} from "../../network/sports_meet";

Vue.use(NavBar)
Vue.use(Popup)
Vue.use(Sticky)
Vue.use(Cascader)
Vue.use(Field)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(ActionSheet)
Vue.use(Button)
Vue.use(Uploader)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Divider)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
export default {
  name: "SportsMeetSeria",
  data() {
    return {
      // dropdown menu
      gender: "男",
      sgroup: "甲",
      category: '100米',
      progress: '预赛',
      genders: [
        // {text: '男', value: '男'},
        // {text: '女', value: '女'},
      ],
      sgroups: [
        // {text: '甲', value: '甲'},
        // {text: '乙', value: '乙'},
        // {text: '丙', value: '丙'},
      ],
      categorys: [
        // {text: '100米', value: '100米'},
        // {text: '200米', value: '200米'},
        // {text: '400米', value: '400米'},
        // {text: '800米', value: '800米'},
        // {text: '1500米', value: '1500米'},
        // {text: '3000米', value: '3000米'},
        // {text: '跳高', value: '跳高'},
        // {text: '跳远', value: '跳远'},
        // {text: '三级跳远', value: '三级跳远'},
        // {text: '铅球', value: '铅球'},
      ],
      progresses: [
        // {text: '预赛', value: '预赛'},
        // {text: '复赛', value: '复赛'},
        // {text: '决赛', value: '决赛'},
      ],
      sportsMeetTitleList: [],
      // dialog
      show: false,
      title: "",

      previewShow: false,
      serial: '',
      previewList: []
    }
  },
  mounted() {
    this.GetSportsMeetMultiTypes();
    this.getSportsMeetTitleList();
  },
  methods: {
    async GetSportsMeetMultiTypes() {
      const res = await GetSportsMeetMultiTypes();
      this.categorys = [];
      this.genders = [];
      this.progresses = [];
      this.sgroups = [];
      for (let i in res.category) {
        this.categorys.push({text: res.category[i], value: res.category[i]});
      }
      for (let i in res.gender) {
        this.genders.push({text: res.gender[i], value: res.gender[i]});
      }
      for (let i in res.progress) {
        this.progresses.push({text: res.progress[i], value: res.progress[i]});
      }
      for (let i in res.sgroup) {
        this.sgroups.push({text: res.sgroup[i], value: res.sgroup[i]});
      }

    },
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("/more");
    },
    async getSportsMeetTitleList() {
      const res = await GetSportsMeetTitleList(this.gender, this.sgroup, this.category, this.progress);
      this.sportsMeetTitleList = res;
    },
    dropdownItemChange() {
      this.getSportsMeetTitleList();
    },
    dialogShow(title) {
      this.title = title;
      this.show = true;
    },
    async changeSerial() {
      if (this.serial.trim() == "") {
        Toast('序号不可为空');
        return;
      }
      const res = await ChangeSportsMeetSerial(this.title, this.serial);
      if (res) {
        this.getSportsMeetTitleList();
      } else {
        Toast('修改失败，该编号可能已被使用');
      }
      this.serial = '';
    },
    async onPreview() {
      let res = await GetSerial('all_admin');
      this.previewList = res;
      this.previewShow = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
  }
}
</script>

<style scoped>
.content {
  padding: 16px 16px 160px;
}
</style>
